module.exports = __webpack_public_path__ + "static/media/beast-eyes.0769e2d6.png";